import React from "react";

function LoaderScreen() {
  return (
    <div className="loader-screen">
      <i className="fas fa-spin fa-spinner" />
    </div>
  );
}

export default LoaderScreen;
